import moment from 'moment';
import { CalendarRangeOutput, CalendarRangeType } from '../models';

const DATE_FORMAT = 'DD/MM/YYYY';
const MONTH_FORMAT = 'MM/YYYY';
const YEAR_FORMAT = 'YYYY';

/**
 * Traduce la salida del organism-calendar-filter a un rango concreto de fechas.
 * Hace falta para los endpoints que solo reciben fecha_inicial/fecha_final en vez
 * del 'Tipo_consulta_BD' que usa el resto del gateway.
 */
export function calendarRangeToDates(calendarType: CalendarRangeOutput): { fecha_inicial: string; fecha_final: string } | null {
  switch (calendarType.tipo) {
    // El filtro ya entrega ambos extremos en DD/MM/YYYY
    case CalendarRangeType.RANGO_DIAS:
    case CalendarRangeType.SEMANA_ANTERIOR:
      return calendarType.fechaInicio && calendarType.fechaFin
        ? { fecha_inicial: calendarType.fechaInicio, fecha_final: calendarType.fechaFin }
        : null;

    // Llegan como MM/YYYY: se expanden al primer y último día del rango
    case CalendarRangeType.RANGO_MESES:
      return buildRange(calendarType.fechaInicio, calendarType.fechaFin, MONTH_FORMAT, 'month');

    case CalendarRangeType.MES_ACTUAL:
    case CalendarRangeType.MES_ANTERIOR:
      return buildRange(calendarType.date, calendarType.date, MONTH_FORMAT, 'month');

    case CalendarRangeType.ANIO_ACTUAL:
    case CalendarRangeType.ANIO_ANTERIOR:
      return buildRange(calendarType.date, calendarType.date, YEAR_FORMAT, 'year');

    case CalendarRangeType.DIA_ANTERIOR:
    case CalendarRangeType.DIA_ESPECIFICO:
      return buildRange(calendarType.date, calendarType.date, DATE_FORMAT, 'day');

    default:
      return null;
  }
}

function buildRange(
  from: string | undefined,
  to: string | undefined,
  format: string,
  unit: moment.unitOfTime.StartOf
): { fecha_inicial: string; fecha_final: string } | null {
  if (!from || !to) return null;

  const start = moment(from, format, true);
  const end = moment(to, format, true);
  if (!start.isValid() || !end.isValid()) return null;

  return {
    fecha_inicial: start.startOf(unit).format(DATE_FORMAT),
    fecha_final: end.endOf(unit).format(DATE_FORMAT)
  };
}
